import * as React from 'react';
import { Image, Root } from './styled';

interface LogoStatelessProps {
    url?: string | null;
    name: string;
}

const LogoStateless: React.StatelessComponent<LogoStatelessProps> = ({ url, name }) => {
    const content = url ? <Image src={url} alt={name} /> : <span>{name}</span>;

    return <Root>{content}</Root>;
};

export default LogoStateless;
